import { MenuItem, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  CustomAutoComplete,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';
import { ALL_WAREHOUSES_FILTER } from '../constants/inventoryArticlesConstants';
import {
  formatMovementDate,
  formatMovementType,
  formatStockQuantity,
  getWarehouseLabel,
} from '../utils/inventoryArticlesUtils';

const ArticleStockMovementsTable = ({
  movements = [],
  warehousesByUuid = {},
  warehouseFilter,
  warehouseOptions = [],
  onWarehouseFilterChange,
  isLoading = false,
}) => {
  return (
    <>
      <CustomAutoComplete
        label="Filtrar por depósito"
        name="warehouseFilter"
        value={warehouseFilter}
        onChange={(event) => onWarehouseFilterChange?.(event.target.value)}
        sx={{ maxWidth: 360, mb: 2 }}
      >
        <MenuItem value={ALL_WAREHOUSES_FILTER}>Todos los depósitos</MenuItem>
        {warehouseOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomAutoComplete>

      <GeneralTableBox>
        <Table size="small">
          <TableHead>
            <TableRow>
              <HeadTableCell>Fecha</HeadTableCell>
              <HeadTableCell>Depósito</HeadTableCell>
              <HeadTableCell>Tipo</HeadTableCell>
              <HeadTableCell>Cantidad</HeadTableCell>
              <HeadTableCell>Stock anterior</HeadTableCell>
              <HeadTableCell>Stock nuevo</HeadTableCell>
              <HeadTableCell>Motivo</HeadTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableBodySkeleton colSpan={7} />
            ) : movements.length === 0 ? (
              <NoDataSkeleton colSpan={7} message="No hay movimientos para mostrar" />
            ) : (
              movements.map((movement) => (
                <TableRow key={movement.uuid}>
                  <RowTableCell>{formatMovementDate(movement.created_at)}</RowTableCell>
                  <RowTableCell>
                    {getWarehouseLabel(warehousesByUuid, movement.uuid_warehouse)}
                  </RowTableCell>
                  <RowTableCell>{formatMovementType(movement.movement_type)}</RowTableCell>
                  <RowTableCell>{formatStockQuantity(movement.quantity)}</RowTableCell>
                  <RowTableCell>{formatStockQuantity(movement.previous_quantity)}</RowTableCell>
                  <RowTableCell>{formatStockQuantity(movement.new_quantity)}</RowTableCell>
                  <RowTableCell>{movement.observations || '-'}</RowTableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </GeneralTableBox>
    </>
  );
};

export default ArticleStockMovementsTable;
